import { Routes, Route } from "react-router-dom";
import { AppLayout } from "../components/AppLayout";
import Dashboard from "../pages/Dashboard";
import MonthlyTargetSales from "../pages/MonthlyTargetSales";
import SAKpi from "../pages/SAKpi";
import MonthlyKpi from "../pages/MonthlyKpi";

export default function AuthenticatedRoutes(props) {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="projects" element={<Dashboard />} />
        <Route path="planned-sales" element={<MonthlyTargetSales />} />
        <Route path="sa-kpi" element={<SAKpi />} />
        <Route path="monthly-kpi" element={<MonthlyKpi />} />
      </Route>
    </Routes>
  );
}
